"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "flex flex-row items-center gap-1 h-full border-gray focus-within:ring-blue focus-within:ring-opacity-50 rounded-md transition-all duration-300" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "marso-icon-close text-dark-gray" }, null, -1);
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = ["value", "id"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
    key: 1,
    class: "bg-white cursor-default text-center p-2 border-t border-gray cursor-pointer hover:bg-gray"
};
const vue_3 = require("vue");
const ShopInput_vue_1 = __importDefault(require("../ShopInput.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SearchInput',
    props: {
        placeholder: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        displayValue: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            required: true,
            default: () => []
        },
        customClass: {
            type: String,
            required: false,
            default: ''
        },
        displayValueAfterSelection: {
            type: Boolean,
            default: false,
            required: false
        },
        caseSensitive: {
            type: Boolean,
            default: false
        }
    },
    emits: ["selected", "reset"],
    setup(__props, { expose, emit }) {
        var _a;
        const props = __props;
        const filteredOptions = (0, vue_3.ref)(props.options);
        const displayValue = (0, vue_3.ref)(props.displayValue);
        const searchedValue = (0, vue_3.ref)('');
        const searchVisible = (0, vue_3.ref)(false); //Dont change the v-show to v-if!
        const componentId = (_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid;
        let searcher = null;
        let searcherInput = null;
        const openSearcher = () => {
            searchVisible.value = true;
            (0, vue_3.nextTick)(() => {
                searcherInput = document.getElementById(`searcher_input_${componentId}`);
                if (searcherInput === null) {
                    return;
                }
                searcherInput.focus();
            });
        };
        const clickOutsideListener = (event) => {
            if (searcher !== null && !searcher.contains(event.target)) {
                searchVisible.value = false;
                searchedValue.value = '';
                return;
            }
        };
        (0, vue_3.onMounted)(() => {
            searcher = document.getElementById(`searcher_${componentId}`);
            document.addEventListener('click', clickOutsideListener);
        });
        (0, vue_3.onUnmounted)(() => {
            document.removeEventListener('click', clickOutsideListener);
        });
        const searchedValueChanged = (event) => {
            searchedValue.value = event.target.value;
            filteredOptions.value = props.options.filter((option) => {
                if (props.caseSensitive) {
                    return option.value.startsWith(searchedValue.value);
                }
                return option.value.toUpperCase().startsWith(searchedValue.value.toUpperCase());
            });
        };
        (0, vue_3.watch)(() => props.options, (value) => {
            filteredOptions.value = props.options;
        });
        const itemSelected = (item) => {
            displayValue.value = props.displayValueAfterSelection ? item.value : item.label;
            searchedValue.value = '';
            searchVisible.value = false;
            emit("selected", item);
        };
        const reset = () => {
            displayValue.value = '';
            searchedValue.value = '';
            searchVisible.value = true;
            emit("reset");
        };
        expose({ reset });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: `searcher_${(0, vue_2.unref)(componentId)}`,
                class: "relative border border-gray rounded-md w-full lg:w-64"
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                        type: "text",
                        placeholder: __props.placeholder,
                        label: __props.label,
                        readonly: "",
                        autocomplete: false,
                        modelValue: displayValue.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((displayValue).value = $event)),
                        icon: "marso-icon-search",
                        onFocusin: openSearcher
                    }, null, 8, ["placeholder", "label", "modelValue"]),
                    (displayValue.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 0,
                            class: "h-full block border-l-1 border-gray p-3",
                            onClick: reset
                        }, _hoisted_4))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("ul", {
                    class: (0, vue_2.normalizeClass)(["absolute left-0 z-10 w-full bg-white block shadow-sm", __props.customClass])
                }, [
                    (0, vue_2.createElementVNode)("li", null, [
                        (0, vue_2.createElementVNode)("input", {
                            value: searchedValue.value,
                            onInput: searchedValueChanged,
                            id: `searcher_input_${(0, vue_2.unref)(componentId)}`,
                            class: "w-full p-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300 border border-blue border-2"
                        }, null, 40, _hoisted_5)
                    ]),
                    (filteredOptions.value.length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, (0, vue_2.renderList)(10, (i) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: i }, [
                                (filteredOptions.value[i - 1])
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                        key: 0,
                                        class: "p-2 hover:bg-gray",
                                        onClick: ($event) => (itemSelected(filteredOptions.value[i - 1]))
                                    }, (0, vue_2.toDisplayString)(filteredOptions.value[i - 1].label), 9, _hoisted_6))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ], 64));
                        }), 64))
                        : (0, vue_2.createCommentVNode)("", true),
                    (filteredOptions.value.length > 10)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_7, "..."))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 2), [
                    [vue_2.vShow, searchVisible.value]
                ])
            ], 8, _hoisted_1));
        };
    }
});
